import { useCallback, useState } from 'react';

// UI-only selection until the case API provides bulk actions.
export function useCaseSelection() {
  const [selectedNumbers, setSelectedNumbers] = useState<Array<string>>([]);

  const isSelected = useCallback((caseNumber: string) => selectedNumbers.includes(caseNumber), [selectedNumbers]);

  const setSelection = useCallback((caseNumbers: Array<string>, isChecked: boolean) => {
    setSelectedNumbers((current) =>
      isChecked
        ? Array.from(new Set([...current, ...caseNumbers]))
        : current.filter((number) => !caseNumbers.includes(number)),
    );
  }, []);

  return { selectedNumbers, isSelected, setSelection };
}
